import 'core-js';

import currencyConverterApp from '../components/currencyConverterApp';
import OfficeMap from '../components/OfficeMap';
import LoanApplicationForm from '../components/loanapplication/LoanApplicationForm';
import '../_formieForms';

var currencyConverters = document.querySelectorAll('.currencyConverter');

var Vue = window.Vue

if (currencyConverters) {
  currencyConverters.forEach((currencyConverter) => {
    const appHeight = currencyConverter.offsetHeight;
    currencyConverter.style.height = `${appHeight}px`;

    new Vue({
      data() {
        return {
          region: currencyConverter.getAttribute('data-region'),
          lang: currencyConverter.getAttribute('data-lang'),
          cardCurrency: 'EUR',
          bankFee: '1.95', // Default bank fee used for Finland
        }
      },
      el: currencyConverter,
      components: {
        currencyConverterApp
      },
      mounted: function () {
        if (this.region === 'SE') {
          this.cardCurrency = 'SEK'
          this.bankFee = '1.65'
        };
      },
      render: function (createElement) {
        return createElement(currencyConverterApp, {
          props: {
            region: this.region,
            lang: this.lang,
            cardCurrency: this.cardCurrency,
            bankFee: this.bankFee,
          }
        });
      }
    })
  });
}

const offices = document.getElementById('offices');

if (offices) {
  new Vue({
    el: offices,
    components: { OfficeMap },
    computed: {
      apiKey() {
        return this.$el.dataset.apiKey;
      },
      officeList() {
        return JSON.parse(this.$el.dataset.officeList);
      },
      countryList() {
        return JSON.parse(this.$el.dataset.countryList);
      },
      translations() {
        return JSON.parse(this.$el.dataset.translations);
      }
    },
    render: function (createElement) {
      return createElement(OfficeMap, {
        props: {
          apiKey: this.apiKey,
          offices: this.officeList,
          countries: this.countryList,
          strings: this.translations,
        }
      });
    }
  });
}


const loanApplication = document.getElementById('loan-application-form');
if (loanApplication) {
  new Vue({
    el: loanApplication,
    components: { LoanApplicationForm },
    render: function (createElement) {
      return createElement(LoanApplicationForm, {
        props: {
          options: JSON.parse(this.$el.dataset.options),
          translations: JSON.parse(this.$el.dataset.translations),
          links: JSON.parse(this.$el.dataset.links),
        }
      });
    }
  })
}